import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=9da4b742&scoped=true&lang=pug"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"
import style0 from "./pay.vue?vue&type=style&index=0&id=9da4b742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da4b742",
  null
  
)

export default component.exports